import { isAxiosError } from 'axios';
import { useEffect } from 'react';
import { useKeycloak } from '@/providers/keycloak-provider';

/**
 * A 409 on `GET /user/by-iam-id/...` means the Keycloak session points at an
 * IAM id the API no longer recognises (user deleted / re-provisioned on the
 * backend while the SSO session is still alive). The only recovery is to drop
 * the stale session and force a fresh sign-in.
 */
const useLogoutOnUserConflict = (error: unknown) => {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (!isAxiosError(error) || error.response?.status !== 409) return;
    if (!keycloak?.authenticated) return;
    keycloak.logout({ redirectUri: window.location.origin });
  }, [error, keycloak]);
};

export default useLogoutOnUserConflict;
